export default __webpack_public_path__ + "static/media/tax-rate-options-bands.386025a3.svg";